import { signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

export class SelectionService<T> {

    private _$selection = signal<T[]>([]);
    public readonly $selection = this._$selection.asReadonly();
    public readonly selection$ = toObservable(this._$selection);

    public get selection() { return this.$selection() };
    public get count() { return this.$selection().length };

    private _allowMultiSelect = true;
    public get allowMultiSelect() { return this._allowMultiSelect; }
    public set allowMultiSelect(value: boolean) {
        this._allowMultiSelect = value;
        this.clear();
    }

    public select(item: T) {

        if (this.selection.includes(item)) {
            return;
        }

        const selection = this.allowMultiSelect
            ? [...this.selection, item]
            : [item];

        this._$selection.set(selection);
    }


    public selectMany(items: T[]) {

        if (!items.length) {
            return;
        }

        if (!this.allowMultiSelect) {
            items = [items[0]];
        }

        let newSelect: T[] = [];
        for (const item of items) {
            if (!this.selection.includes(item)) {
                newSelect.push(item);
            }
        }

        this._$selection.set([...this.selection, ...newSelect]);
    }

    public deselect(item: T) {
        const selection = this.selection.filter(x => x !== item);
        this._$selection.set(selection);
    }

    public toggle(item: T) {

        let selection: T[] = [];

        if (!this.allowMultiSelect) {
            if (this.selection.includes(item)) {
                selection = [];
            } else {
                selection = [item];
            }
        } else {

            selection = this.selection.includes(item)
                ? this.selection.filter(x => x !== item)
                : [...this.selection, item];
        }

        this._$selection.set(selection);
    }

    public clear() {
        this._$selection.set([]);
    }

    public isSelected(item: T) {
        return this.selection.includes(item);
    }
}